import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MainHeader from '../../components/common/MainHeader';
import { URL_INTERFACE_AX } from '../../constance/urls';
import { POST } from '../../utils/HttpClient';
import { Toast } from '../../utils/Toast';
import * as _ from 'lodash'
import InterfaceAXTransactionModal from '../../components/interface-ax/InterfaceAXTransactionModal';
import Title from 'antd/es/typography/Title';
import TSTable from '../../components/common/TSTable';
import { Button, Space, Form, DatePicker, Input, Row, Col } from 'antd';
import { FileTextFilled } from '@ant-design/icons'
import { Content } from 'antd/es/layout/layout';
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from '../../constance/strings';
import dayjs from 'dayjs';
import { useDebounce } from 'use-debounce';
import { BLUE_COLOR } from '../../constance/color';
import ColorButton from '../../components/common/ColorButton';


export default function InterfaceAXMovementReceiptView() {

  const { t } = useTranslation();
  const tableRef = React.useRef(null);
  const [target, setTarget] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMsg, setErrMsg] = React.useState(null);
  const [form] = Form.useForm();
  const date = Form.useWatch('produce_date', form)
  const searchText = Form.useWatch('search', form)
  const [debouncedText] = useDebounce(searchText, 500);
  const formattedDate = date ? dayjs(date).format(DATE_FORMAT) : null;

  React.useEffect(() => {
    if (tableRef.current) {
      tableRef.current.fetch();
    }
  }, [date, debouncedText])

  const columns = React.useMemo(() => [
    {
      title: t('date'),
      dataIndex: 'created',
      render: (__, original) => new Date(original.created).toLocaleString('en-GB')
    },
    {
      title: t('wood_imports.order_no'),
      dataIndex: 'order_no',
    },
    {
      title: t('truck_transactions.company'),
      dataIndex: 'truck_company_name',
    },
    {
      title: t('trucks.type'),
      dataIndex: 'truck_type_name',
    },
    {
      title: () => null,
      dataIndex: 'id',
      render: (__, original) => {
        const target = _.get(original, 'id', null);
        const progressing = _.get(original, 'interface_progressing', false)
        return (
          <>
            <Space>
              <ColorButton
                variant='outlined'
                color='primary'
                override={BLUE_COLOR}
                disabled={progressing}
                onClick={() => !progressing ? handleDoInterfaceAX(target) : null}
              >
                {progressing ? t('progressing') : t('do_interface_ax')}
              </ColorButton>
              <ColorButton
                variant='outlined'
                color='primary'
                override={BLUE_COLOR}
                icon={<FileTextFilled />}
                onClick={() => setTarget(target)} />
            </Space>
          </>
        )
      }
    }
  ], []);

  const handleDoInterfaceAX = async (id) => {
    if (!tableRef.current) {
      return;
    }
    setIsLoading(true);
    setErrMsg(null);
    try {
      const response = await POST(`${URL_INTERFACE_AX.MOVEMENT_RECEIPT}${id}/do_interface/`)
      tableRef.current.fetch();
      Toast.success(t('success'))

    } catch (error) {
      setErrMsg(error.errorMessages);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div>
      <MainHeader />
      <Content style={{ margin: '24px', marginTop: '7em' }}>
        <Title level={2}>
          {t('menus.interface_ax')}: {t('menus.interface_ax_menus.movement_receipt')}
        </Title>
        <div style={{ textAlign: 'left' }}>

          <Form form={form}>
            <Row gutter={16}>
              <Col sm={24} md={12} lg={6}>
                <Form.Item label={t('searchs.fields.date')} name={"produce_date"}>
                  <DatePicker
                    format={HUMAN_DATE_FORMAT}
                    placeholder={t('searchs.placeholders.date')}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              <Col sm={24} md={12} lg={6}>
                <Form.Item label={t('search')} name={"search"}>
                  <Input
                    placeholder={t('search')}
                    allowClear
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>

        </div>
        <TSTable
          ref={tableRef}
          url={URL_INTERFACE_AX.MOVEMENT_RECEIPT}
          columns={columns}
          params={{ date: formattedDate, search: debouncedText }}
        />
        <InterfaceAXTransactionModal
          open={target != null}
          onClose={() => setTarget(null)}
          onInterfaceAX={handleDoInterfaceAX}
          url={URL_INTERFACE_AX.MOVEMENT_RECEIPT}
          target={target} />
      </Content>
    </div>
  )
}